import { isAsync, isPromise } from '../tools';
import { promiseDeprecated, promiseDeprecatedFromClonedModel, promiseDeprecatedFromLocalService, promiseDeprecatedFromLocalServicePure } from './constants';
export var errorFlags = [promiseDeprecated, promiseDeprecatedFromClonedModel, promiseDeprecatedFromLocalService, promiseDeprecatedFromLocalServicePure];
export var promiseDeprecatedError = 'the promise is deprecated by race condition';
export var isRaceError = function isRaceError(error) {
  return error === promiseDeprecatedError;
};
var genRaceQueue = function genRaceQueue(deprecatedError) {
  var errorFlag = deprecatedError || promiseDeprecated;
  var raceQueue = [];
  return {
    push: function push(p, customerErrorFlag) {
      var _raceQueue, _raceQueue2, _raceQueue4;
      var flag = customerErrorFlag || errorFlag;
      (_raceQueue = raceQueue) === null || _raceQueue === void 0 ? void 0 : _raceQueue.forEach(function (t) {
        if (isPromise(t)) {
          if (!errorFlags.some(function (ef) {
            return t === null || t === void 0 ? void 0 : t[ef];
          })) {
            t[flag] = true;
          }
        }
      });
      if (!((_raceQueue2 = raceQueue) !== null && _raceQueue2 !== void 0 && _raceQueue2.some(function (rqp) {
        return isPromise(rqp);
      }))) {
        var _raceQueue3;
        (_raceQueue3 = raceQueue) === null || _raceQueue3 === void 0 ? void 0 : _raceQueue3.splice(0);
      }
      (_raceQueue4 = raceQueue) === null || _raceQueue4 === void 0 ? void 0 : _raceQueue4.push(p);
      return p;
    },
    clear: function clear(customerErrorFlag) {
      var _raceQueue5, _raceQueue6;
      var flag = customerErrorFlag || errorFlag;
      (_raceQueue5 = raceQueue) === null || _raceQueue5 === void 0 ? void 0 : _raceQueue5.forEach(function (rp) {
        if (isAsync(rp)) {
          rp[flag] = true;
        }
      });
      (_raceQueue6 = raceQueue) === null || _raceQueue6 === void 0 ? void 0 : _raceQueue6.splice(0);
    },
    destroy: function destroy(customerErrorFlag) {
      var _raceQueue7, _raceQueue8;
      var flag = customerErrorFlag || errorFlag;
      (_raceQueue7 = raceQueue) === null || _raceQueue7 === void 0 ? void 0 : _raceQueue7.forEach(function (rp) {
        if (isAsync(rp)) {
          rp[flag] = true;
        }
      });
      (_raceQueue8 = raceQueue) === null || _raceQueue8 === void 0 ? void 0 : _raceQueue8.splice(0);
      raceQueue = null;
    },
    getIndex: function getIndex(p) {
      var _ref;
      return (_ref = raceQueue || []) === null || _ref === void 0 ? void 0 : _ref.indexOf(p);
    },
    slice: function slice() {
      var _ref2;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_ref2 = raceQueue || []) === null || _ref2 === void 0 ? void 0 : _ref2.slice.apply(_ref2, args);
    },
    replace: function replace() {
      var _ref3, _raceQueue10;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var p = args[0],
        by = args[1];
      var index = (_ref3 = raceQueue || []) === null || _ref3 === void 0 ? void 0 : _ref3.indexOf(p);
      if (args.length === 1) {
        var _raceQueue9;
        (_raceQueue9 = raceQueue) === null || _raceQueue9 === void 0 ? void 0 : _raceQueue9.splice(index, 1);
        return;
      }
      (_raceQueue10 = raceQueue) === null || _raceQueue10 === void 0 ? void 0 : _raceQueue10.splice(index, 1, by);
    },
    __UNSAFE__getQueue: function __UNSAFE__getQueue() {
      return raceQueue;
    }
  };
};
export default genRaceQueue;